import StatisticProductSimpleView from './StatisticProductSimpleView'

export default StatisticProductSimpleView
